export const Logo = () => (
  <a href="#top" className="flex items-center group" data-testid="nav-logo" aria-label="Impact Activations home">
    <img
      src="/logo.png"
      alt="Impact Activations"
      className="h-9 w-auto transition-transform duration-300 group-hover:-skew-x-3"
    />
  </a>
);
